// Kilomètres du covoiturage (D-069) : qui conduit à un match à l'extérieur fait l'aller-retour
// depuis notre gymnase. Dans « Mes badges » de chacun (D-100) ; le total par conducteur au bureau.
import { clubCarpoolKm, myCarpoolKm, type CarpoolTrip } from '../lib/api';
import { parseLocalDate } from '../domain/schedule';
import type { Ctx } from './context';
import { html, mount } from './dom';

const fmt = (n: number) => Math.round(n).toLocaleString('fr-FR');
const shortDay = (d: string) => parseLocalDate(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });

/** Mes badges : mes km de conducteur cette saison (rien si je n'ai pas conduit, avec `hideEmpty`). */
export async function renderMyKm(el: HTMLElement, ctx: Ctx, opts: { hideEmpty?: boolean } = {}): Promise<void> {
  if (!ctx.club) return;
  const trips = await myCarpoolKm(ctx.club.id).catch(() => [] as CarpoolTrip[]);
  if (!trips.length && opts.hideEmpty) { mount(el, html``); return; }
  const total = trips.reduce((a, t) => a + Number(t.km), 0);
  const est = trips.some(t => t.estimated);
  mount(el, html`
    <section class="block km-block">
      <div class="block-head"><h3>Mes déplacements</h3></div>
      ${trips.length ? html`
        <p class="km-total"><b>${est ? '≈ ' : ''}${fmt(total)} km</b> <span class="muted small">cette saison · ${trips.length} ${trips.length > 1 ? 'matchs' : 'match'} à l'extérieur, aller-retour</span></p>
        <ul class="vp-hist">${trips.slice(0, 12).map(t => html`
          <li><span class="muted small">${shortDay(t.day)}</span>
            <span><strong>${t.title}</strong>${t.passengers ? html` <span class="muted small">· ${t.passengers} ${t.passengers > 1 ? 'passagers' : 'passager'}</span>` : ''}</span>
            <b>${t.estimated ? '≈ ' : ''}${fmt(Number(t.km))} km</b></li>`)}</ul>
        ${est ? html`<p class="hint">≈ : distance estimée (vol d'oiseau × 1,3) ; elle devient exacte quand le trajet du match est calculé.</p>` : ''}`
      : html`<p class="muted small">Quand tu conduis à un match à l'extérieur (covoiturage de la fiche de match), tes kilomètres aller-retour s'ajoutent ici.</p>`}
    </section>`);
}

/** Bureau : le total de la saison par conducteur. */
export async function renderClubKm(el: HTMLElement, ctx: Ctx): Promise<void> {
  if (!ctx.club) return;
  const rows = await clubCarpoolKm(ctx.club.id).catch(() => []);
  if (!rows.length) { mount(el, html``); return; }
  const total = rows.reduce((a, r) => a + Number(r.km), 0);
  mount(el, html`
    <details class="alt-box">
      <summary>Kilomètres des conducteurs · ${fmt(total)} km cette saison</summary>
      <ul class="vp-hist">${rows.map(r => html`
        <li><span class="muted small">${r.trips} ${r.trips > 1 ? 'trajets' : 'trajet'}</span><span><strong>${r.name}</strong></span>
          <b>${r.estimated ? '≈ ' : ''}${fmt(Number(r.km))} km</b></li>`)}</ul>
      <p class="hint">Aller-retour depuis le gymnase, d'après le covoiturage des matchs à l'extérieur. Base d'une attestation d'abandon de frais kilométriques, si le club la propose.</p>
    </details>`);
}
